export default __webpack_public_path__ + "static/media/FrostFields.35440d5d.jpg";